import { render, staticRenderFns } from "./backlog-list.vue?vue&type=template&id=c2f368d8&scoped=true&"
import script from "./backlog-list.vue?vue&type=script&lang=js&"
export * from "./backlog-list.vue?vue&type=script&lang=js&"
import style0 from "./backlog-list.vue?vue&type=style&index=0&id=c2f368d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f368d8",
  null
  
)

export default component.exports